import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from '@angular/core';
import * as _ from "lodash";

require('./route-totals.scss');
@Component({
  standalone: false,
  selector: 'app-route-totals',
  templateUrl: './route-totals.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouteTotalsComponent implements OnInit {
  @Input() weight: number;
  @Input() dimensions: any;
  @Input() volume?: any;
  @Input() numberOfPackages: number
  @Input() numberOfSpots: number;
  @Input() numberOfPallets: number;
  @Input() extraWeight: number;
  @Input() extraDimensions: any;
  @Input() extraNumberOfPackages: number;
  @Input() extraNumberOfSpots: number;
  @Input() extraNumberOfPallets: number;
  @Input() subVolumeList: any;

  public weightUnit: any;
  public volumeUnit: any;
  public labelsMap: any;


  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.weightUnit = this.splitService.getWeightUnit();
    this.volumeUnit = this.splitService.getVolumeUnit();

    this.labelsMap = {};
    const siteLabels = this.splitService.getSiteLabels();
    _.forEach(siteLabels, (l) => {
      this.labelsMap[l.name] = l;
    })
  }

}
